import { atom } from "recoil";

export const isBoard = atom({
  key: "isBoard",
  default: [],
});
export const isContents = atom({
  key: "isContents",
  default: [],
});
